module.exports = __webpack_public_path__ + "img/wanjie-li-untitled.94c1501.jpg";